// TODO: Delete this component after <NextMeeting/> refactor

import NextMeeting, { NextMeetingDateToShow } from '@components/V3/NextMeeting';
import { Feedback } from '@modules/Mentor/components/FeedbackModal/FeedbackModal';
import { MeetingWithHomework } from '@shared/common';
import React from 'react';

interface Props {
  meeting: MeetingWithHomework;
  refetch?: () => void;
  isUserProfileView?: boolean;
  isMentor?: boolean;
  dateToShow?: NextMeetingDateToShow;
  setShowFeedbackModal: React.Dispatch<React.SetStateAction<boolean>>;
  setFeedbackModalData: React.Dispatch<
    React.SetStateAction<{
      id: string;
      feedback: Feedback;
      title: string;
    }>
  >;
}

const MeetingNeedingFeedbackMentor: React.FC<Props> = (props: Props) => {
  const {
    meeting,
    isMentor,
    dateToShow,
    isUserProfileView,
    setShowFeedbackModal,
    setFeedbackModalData,
  } = props;
  const { students } = meeting;

  const name = students[0]?.fullName || '';

  return (
    <NextMeeting
      isUserProfileView={isUserProfileView}
      meetingNeedingFeedback={true}
      meeting={meeting}
      otherName={name}
      isMentor={isMentor}
      hideJoinBtn
      dateToShow={dateToShow}
      setShowFeedbackModal={setShowFeedbackModal}
      setFeedbackModalData={setFeedbackModalData}
    />
  );
};

export default MeetingNeedingFeedbackMentor;
